import React from 'react';
import i18n from '@/utils/i18n';

type CleanOrDirtyTextProps = {
  isClean?: boolean;
  isDirty?: boolean;
};

const CleanOrDirtyText = ({ isClean, isDirty }: CleanOrDirtyTextProps) => {
  return (
    <>
      {(isClean === true || isDirty === false) && (
        <span className="text-success font-weight-bold">
          {i18n.t('Common:clean')}
        </span>
      )}
      {(isDirty === true || isClean === false) && (
        <span className="text-danger font-weight-bold">
          {i18n.t('Common:dirty')}
        </span>
      )}
    </>
  );
};

export default CleanOrDirtyText;
